import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({ name: 'isNewDay' })
export class IsNewDayPipe implements PipeTransform {
  transform(i: number, tableData: any[]) {
    if (i === 0) {
      return true;
    }
    const prevDay = moment(tableData[i - 1]['dtg']).dayOfYear();
    const currentDay = moment(tableData[i]['dtg']).dayOfYear();
    return currentDay !== prevDay;
  }
}
